import classnames from 'classnames';
import { forwardRef, useImperativeHandle, useRef } from 'react';

import { Button } from '../../Button/Button';

import styles from './TextInput.module.scss';
import { TextInputProps } from './TextInput.types';

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      type = 'text',
      size = 'large',
      leftIcon,
      rightIcon,
      onRightIconClick,
      containerClassName,
      className,
      disabled,
      error,
      success,
      onChange,
      onValueChange,
      ...props
    },
    ref
  ) => {
    const innerRef = useRef<HTMLInputElement>(null);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    useImperativeHandle(ref, () => innerRef.current!);

    return (
      <div
        className={classnames(styles.container, containerClassName, styles[size], {
          [styles.error]: error,
          [styles.success]: success,
          [styles.disabled]: disabled,
        })}
        onClick={() => innerRef.current?.focus()}
      >
        {leftIcon && (
          <span data-icon-size="medium" className={styles.leftIcon}>
            {leftIcon}
          </span>
        )}
        <input
          type={type}
          ref={innerRef}
          disabled={disabled}
          className={classnames(styles.input, className)}
          onChange={event => {
            onChange?.(event);
            onValueChange?.(event.currentTarget.value);
          }}
          {...props}
        />
        {rightIcon && (
          <span data-icon-size="medium" className={styles.rightIcon}>
            {onRightIconClick ? (
              <Button disabled={disabled} variant="tertiary" onClick={onRightIconClick}>
                {rightIcon}
              </Button>
            ) : (
              rightIcon
            )}
          </span>
        )}
      </div>
    );
  }
);
